export default "__VITE_ASSET__b6277de3__"